/**
 * Tool approval query operations - Delete
 */

import { getSupabaseClient } from '../../supabase-client.js';
import { logger } from '../../../logger.js';

/**
 * Delete a tool approval
 */
export async function deleteApproval(approvalId: string): Promise<void> {
  try {
    const client = getSupabaseClient();

    const { error } = await client
      .from('meridian_tool_approvals')
      .delete()
      .eq('id', approvalId);

    if (error) {
      throw error;
    }
  } catch (error) {
    logger.error('error deleting approval', error, { op: 'deleteApproval' });
    throw error;
  }
}
